import { render, staticRenderFns } from "./NoUsers.vue?vue&type=template&id=41604e58&"
import script from "./NoUsers.vue?vue&type=script&lang=js&"
export * from "./NoUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports